import React from 'react';
import { Box, makeStyles } from '@material-ui/core';
import { MessageSnackbar } from '../components/MessageSnackbar';
import bg from '../static/images/background.jpg';

interface LayoutProps {
  children?: React.ReactNode;
}

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: `env(safe-area-inset-top)`,
    paddingBottom: `env(safe-area-inset-bottom)`,
    paddingLeft: `env(safe-area-inset-left)`,
    paddingRight: `env(safe-area-inset-right)`,
    background: `url(${bg})`,
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  },
}));

const NotAuthorizedLayout: React.FC<LayoutProps> = (props) => {
  const { children } = props;

  const classes = useStyles();

  return (
    <Box className={classes.root}>
      {children}
      <MessageSnackbar />
    </Box>
  );
};

export default NotAuthorizedLayout;
